var _excluded = ["selectProps", "innerProps", "isFocused", "isDisabled"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { components } from 'react-select';
import { Text } from "../..";
import { isEmpty } from "../../../helpers/data";
export var Placeholder = function Placeholder(_ref) {
  var selectProps = _ref.selectProps,
      innerProps = _ref.innerProps,
      isFocused = _ref.isFocused,
      isDisabled = _ref.isDisabled,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var value = selectProps.value,
      variant = selectProps.variant,
      TextFieldProps = selectProps.TextFieldProps;
  var placeholder = TextFieldProps.placeholder,
      required = TextFieldProps.required;
  return variant === 'inline' && isEmpty(value) && !isFocused ? /*#__PURE__*/React.createElement(components.Placeholder, restProps, /*#__PURE__*/React.createElement(Text, _extends({
    fontSize: 2,
    color: isDisabled ? 'grey.400' : 'grey.600'
  }, innerProps), placeholder, required && /*#__PURE__*/React.createElement(Text, {
    as: "span",
    color: "red.500",
    pl: 1
  }, "*"))) : /*#__PURE__*/React.createElement(React.Fragment, null);
};